import { BrandSettingsInterface } from '../types/brand-settings'

export const BRAND_SETTINGS_API_URL = '/api/brand-settings'

const defaultBrandThemeSettings: Record<string, BrandSettingsInterface> = {
  classic: {
    name: 'Systeme.io',
    dashboardHostname: process.env.NEXT_PUBLIC_SIO_HOSTNAME || 'systeme.io',
    colors: {
      oldBrandPrimary: '#00A0FF',
      oldTextPrimary: '#142D63',
      oldBackgroundPrimary: '#F1F4F8',
      oldBackgroundHeader: '#142D63',
    },
    logo: {
      id: 0,
      name: 'Systeme.io Logo',
      filename: 'systemeio-logo.svg',
      path: 'https://d1yei2z3i6k35z.cloudfront.net/161/68c03b5dc30e4_systemelogo.svg',
      thumbnail: null,
    },
    favicon: {
      id: 0,
      name: 'Systeme.io Favicon',
      filename: 'systemeio-favicon.svg',
      path: 'https://d2543nuuc0wvdg.cloudfront.net/images/logo_small.svg',
      thumbnail: null,
    },
  },
  aurora: {
    name: 'Aurora Analytics',
    dashboardHostname: 'aurora.systeme.io',
    colors: {
      oldBrandPrimary: '#6D28D9',
      oldTextPrimary: '#E0E7FF',
      oldBackgroundPrimary: '#111827',
      oldBackgroundHeader: '#312E81',
    },
    logo: {
      id: 0,
      name: 'Aurora Analytics Logo',
      filename: 'aurora-analytics-logo.png',
      path: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=256&h=256&q=80',
      thumbnail: null,
    },
    favicon: {
      id: 0,
      name: 'Aurora Analytics Favicon',
      filename: 'aurora-analytics-favicon.png',
      path: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=64&h=64&q=80',
      thumbnail: null,
    },
  },
  ember: {
    name: 'Ember & Stone Studios',
    dashboardHostname: 'ember.systeme.io',
    colors: {
      oldBrandPrimary: '#EA580C',
      oldTextPrimary: '#331307',
      oldBackgroundPrimary: '#FFF4E6',
      oldBackgroundHeader: '#9A3412',
    },
    logo: {
      id: 0,
      name: 'Ember & Stone Logo',
      filename: 'ember-stone-logo.png',
      path: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=256&h=256&q=80',
      thumbnail: null,
    },
    favicon: {
      id: 0,
      name: 'Ember & Stone Favicon',
      filename: 'ember-stone-favicon.png',
      path: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=64&h=64&q=80',
      thumbnail: null,
    },
  },
  pacifica: {
    name: 'Pacifica Wellness Co.',
    dashboardHostname: 'pacifica.systeme.io',
    colors: {
      oldBrandPrimary: '#0EA5E9',
      oldTextPrimary: '#0B3C58',
      oldBackgroundPrimary: '#E0F2FE',
      oldBackgroundHeader: '#0369A1',
    },
    logo: {
      id: 0,
      name: 'Pacifica Wellness Logo',
      filename: 'pacifica-wellness-logo.png',
      path: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=256&h=256&q=80',
      thumbnail: null,
    },
    favicon: {
      id: 0,
      name: 'Pacifica Wellness Favicon',
      filename: 'pacifica-wellness-favicon.png',
      path: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=64&h=64&q=80',
      thumbnail: null,
    },
  },
  tundra: {
    name: 'Tundra Logistics Group',
    dashboardHostname: 'tundra.systeme.io',
    colors: {
      oldBrandPrimary: '#0284C7',
      oldTextPrimary: '#0F172A',
      oldBackgroundPrimary: '#F8FAFC',
      oldBackgroundHeader: '#1E293B',
    },
    logo: {
      id: 0,
      name: 'Tundra Logistics Logo',
      filename: 'tundra-logistics-logo.png',
      path: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=256&h=256&q=80',
      thumbnail: null,
    },
    favicon: {
      id: 0,
      name: 'Tundra Logistics Favicon',
      filename: 'tundra-logistics-favicon.png',
      path: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=64&h=64&q=80',
      thumbnail: null,
    },
  },
}

export type DefaultBrandThemeKey = keyof typeof defaultBrandThemeSettings

const cloneBrandSettings = (settings: BrandSettingsInterface): BrandSettingsInterface => ({
  name: settings.name,
  dashboardHostname: settings.dashboardHostname,
  colors: { ...settings.colors },
  logo: settings.logo ? { ...settings.logo } : null,
  favicon: settings.favicon ? { ...settings.favicon } : null,
})

export const getDefaultBrandSettings = (
  theme: DefaultBrandThemeKey = 'classic',
): BrandSettingsInterface => cloneBrandSettings(defaultBrandThemeSettings[theme])

export const defaultBrandSettings = getDefaultBrandSettings('classic')

export const defaultBrandThemeKeys = Object.keys(
  defaultBrandThemeSettings,
) as DefaultBrandThemeKey[]

export const defaultBrandThemes = defaultBrandThemeSettings
